module.exports = __webpack_public_path__ + "ss.svg?d7cb80668bb19857849a6af79b2c319d";